export const CONFIRMED_CREATE_BRANCH_ACTION = "CONFIRMED_CREATE_BRANCH_ACTION";
export const CONFIRMED_DELETE_BRANCH_ACTION = "CONFIRMED_DELETE_BRANCH_ACTION";
export const CONFIRMED_EDIT_BRANCH_ACTION = "CONFIRMED_EDIT_BRANCH_ACTION";
export const CONFIRMED_GET_BRANCHES = "CONFIRMED_GET_BRANCHES";
